export const Symbol = {
  point: {
    type: "simple-marker",
    style: "circle",
    color: [78, 110, 129], //"#4E6E81",
    outline: {
      color: [121, 183, 220],
      width: 1,
    },
  },
  polyline: {
    type: "simple-line",
    color: [78, 110, 129],
    width: 5,
  },
  polygon: {
    type: "simple-fill",
    color: [121, 183, 220, 0.5],
    outline: {
      color: [78, 110, 129],
      width: 1,
    },
  },
  destinationPoint: {
    type: "simple-marker",
    style: "circle",
    color: "#fff",
    outline: {
      color: [121, 183, 220],
      width: 1,
    },
  },
};
